/**
 * Utility functions for safely handling arrays
 */

/**
 * Safely map over an array, returning empty array if input is not an array
 * @param {any} array - The array to map over
 * @param {Function} callback - The mapping function
 * @returns {Array} - The mapped array or empty array
 */
export const safeMap = (array, callback) => {
  if (!Array.isArray(array)) {
    console.warn('safeMap: Input is not an array:', array);
    return [];
  }
  return array.map(callback);
};

/**
 * Safely filter an array, returning empty array if input is not an array
 * @param {any} array - The array to filter
 * @param {Function} callback - The filter function
 * @returns {Array} - The filtered array or empty array
 */
export const safeFilter = (array, callback) => {
  if (!Array.isArray(array)) {
    console.warn('safeFilter: Input is not an array:', array);
    return [];
  }
  return array.filter(callback);
};

/**
 * Safely get array length, returning 0 if input is not an array
 * @param {any} array - The array to get length of
 * @returns {number} - The length or 0
 */
export const safeLength = (array) => {
  if (!Array.isArray(array)) {
    console.warn('safeLength: Input is not an array:', array);
    return 0;
  }
  return array.length;
};

/**
 * Ensure the input is an array, returning empty array if not
 * @param {any} input - The input to ensure is an array
 * @returns {Array} - The input as array or empty array
 */
export const ensureArray = (input) => {
  if (Array.isArray(input)) {
    return input;
  }
  if (input === null || input === undefined) {
    return [];
  }
  console.warn('ensureArray: Converting non-array to array:', input);
  return [];
};